import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    frameId: String,
    interval: { type: Number, default: 4000 },
    maxAttempts: { type: Number, default: 15 },
    noticeId: String,
    storageKey: String,
    stuckMessage: String,
    terminal: { type: Boolean, default: false },
    url: String
  }

  connect() {
    this.clearTimer()
    if (!this.hasStorageKeyValue) return

    if (this.terminalValue) {
      this.clearAttempts()
      return
    }

    const attempts = this.readAttempts()
    if (attempts >= this.maxAttemptsValue) {
      this.renderStuck()
      return
    }

    this.timer = window.setTimeout(() => this.refreshFrame(), this.intervalValue)
  }

  disconnect() {
    this.clearTimer()
  }

  refreshFrame() {
    const frame = document.getElementById(this.frameIdValue)
    if (!frame || !this.hasUrlValue) return

    this.writeAttempts(this.readAttempts() + 1)

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("poll", Date.now().toString())
    frame.src = url.toString()
  }

  renderStuck() {
    if (!this.hasNoticeIdValue) return

    const notice = document.getElementById(this.noticeIdValue)
    if (notice) notice.textContent = this.stuckMessageValue
  }

  readAttempts() {
    try {
      const value = parseInt(sessionStorage.getItem(this.storageKeyValue) || "0", 10)
      return Number.isNaN(value) ? 0 : value
    } catch (_error) {
      return 0
    }
  }

  writeAttempts(value) {
    try {
      sessionStorage.setItem(this.storageKeyValue, String(value))
    } catch (_error) {}
  }

  clearAttempts() {
    try {
      sessionStorage.removeItem(this.storageKeyValue)
    } catch (_error) {}
  }

  clearTimer() {
    if (this.timer) {
      window.clearTimeout(this.timer)
      this.timer = null
    }
  }
}
